/* eslint-disable */
// ------------------------------------------------------------------
// THIS FILE IS AUTO-GENERATED FROM @stotles/data view configuration schemas.
// DO NOT EDIT. Run `yarn workspace app-service generate-saved-view-types`.
// ------------------------------------------------------------------

export interface NoticeSavedView {
  filterSettings: {
    text?: string;
    stage?: (
      | "STALE_PRE_TENDER"
      | "PRE_TENDER"
      | "OPEN"
      | "CLOSED"
      | "AWARDED"
      | "PIPELINE"
      | "PRE_TENDER_V2"
      | "STALE_PRE_TENDER_V2"
      | "CANCELLED_PRE_TENDER"
      | "OPEN_TENDER"
      | "CLOSED_TENDER"
      | "CANCELLED_TENDER"
      | "UNKNOWN_TENDER"
      | "AWARDED_CONTRACT"
      | "EXPIRED_CONTRACT"
      | "CANCELLED_AWARD"
    )[];
    buyerIds?: number[];
    buyerGuids?: string[];
    awardDate?: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    awardNulls?: boolean;
    closeDate?: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    closeNulls?: boolean;
    addedDate?: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    expiryDate?: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    expiryNulls?: boolean;
    publishDate?: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    countryCode?: string[];
    buyerCategoryId?: string[];
    buyerCategoryNulls?: boolean;
    buyerCountryCodes?: string[];
    buyerRegionIds?: string[];
    value?: {
      from?: number | null;
      to?: number | null;
      nulls?: boolean;
    };
    valueNulls?: boolean;
    showUserHiddenLeads?: string;
    includeAllDisqualifiedStates?: boolean;
    assignee?: string[];
    suppliers?: {
      id?: number[];
      isSme?: boolean | null;
      countryCode?: string[];
      guid?: string[];
      mentionType?: "DIRECTLY_AWARDED" | "MENTIONED_IN_ONLY" | "MENTIONED_OR_DIRECTLY_AWARDED";
    };
    frameworks?: {
      ids?: string[];
      frameworkRelationship?: ("FRAMEWORK_NOTICE" | "CALL_OFF" | "NOT_FRAMEWORK_RELATED")[];
    };
    cpvCodes?: string[];
    includeHiddenNotices?: boolean;
    buyerListIds?: string[];
    signalCategory?: string[];
    signals?: {
      ids?: string[] | null;
      categories?: string[] | null;
    };
    relevanceScore?: ("High" | "Medium" | "Low" | "None")[];
    noticeList?: number;
    noticeLists?: number[];
    cpvDimensions?: string[];
    excludeKeywords?: string[];
    keywords?: string[];
  };
  sortOrder: {
    field: string;
    order: "ASC" | "DESC";
  };
  tableSettings: {
    columns: {
      field:
        | "date_added"
        | "title"
        | "indicator"
        | "relevance_score"
        | "stage"
        | "close_date"
        | "buyer"
        | "user_tag"
        | "published_date"
        | "expiry_date"
        | "award_date"
        | "start_date"
        | "value"
        | "country"
        | "suppliers"
        | "is_sme"
        | "qualification"
        | "hidden_date"
        | "buyer_categories"
        | "assignee"
        | "buyer_list_id"
        | "buyer_list_ids"
        | "framework";
      width?: number;
      title?: string;
      disabled?: boolean;
    }[];
  };
}

export interface DocumentSavedView {
  filterSettings: {
    signalScore: ("None" | "Low" | "Medium" | "High")[];
    title: string;
    organisationIds?: string[];
    buyerTypes?: string[];
    buyerListIds?: string[];
    buyerCountryRegions?: {
      countries?: string[];
      regions?: string[];
      selected?: string[];
    };
    keywords?: string[];
    categories?: string[];
    publishDate?: {
      filter?: {
        from?: string;
        to?: string;
        relativeFrom?: string;
        relativeTo?: string;
      };
    };
  };
  sortOrder: {
    field:
      | "title"
      | "buyers"
      | "signalScore"
      | "category"
      | "publishedAt"
      | "userEmail"
      | "createdAt"
      | "actions"
      | "type";
    order: "ASC" | "DESC";
  };
  tableSettings: {
    columns: {
      field:
        | "title"
        | "buyers"
        | "signalScore"
        | "category"
        | "publishedAt"
        | "userEmail"
        | "createdAt"
        | "actions"
        | "type";
      width?: number;
      title?: string;
      disabled?: boolean;
    }[];
  };
}

export interface NoticeSemanticSavedView {
  filterSettings: {
    topicSearch: string;
    stage: (
      | "PIPELINE"
      | "PRE_TENDER_V2"
      | "STALE_PRE_TENDER_V2"
      | "CANCELLED_PRE_TENDER"
      | "OPEN_TENDER"
      | "CLOSED_TENDER"
      | "CANCELLED_TENDER"
      | "UNKNOWN_TENDER"
      | "AWARDED_CONTRACT"
      | "EXPIRED_CONTRACT"
      | "CANCELLED_AWARD"
    )[];
    buyerIds: string[];
    buyerListIds: string[];
    buyerCategories: string[];
    supplierIds: string[];
    frameworkIds: string[];
    publishDate: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
    };
    expiryDate: {
      from?: string;
      to?: string;
      relativeFrom?: string;
      relativeTo?: string;
      hideNulls?: boolean;
    };
    value: {
      from?: number;
      to?: number;
      hideNulls?: boolean;
    };
  };
  sortOrder: {
    field:
      | "relevanceScore"
      | "title"
      | "stage"
      | "value"
      | "suppliers"
      | "actions"
      | "awardDate"
      | "closeDate"
      | "expiryDate"
      | "publishDate";
    order: "ASC" | "DESC";
  };
  tableSettings: {
    columns: {
      field:
        | "relevanceScore"
        | "title"
        | "stage"
        | "value"
        | "suppliers"
        | "actions"
        | "awardDate"
        | "closeDate"
        | "expiryDate"
        | "publishDate";
      width?: number;
      title?: string;
      disabled?: boolean;
    }[];
  };
}

export type SavedViewConfiguration =
  | NoticeSavedView
  | DocumentSavedView
  | NoticeSemanticSavedView;

export const noticeColumnFields = [
  "date_added",
  "title",
  "indicator",
  "relevance_score",
  "stage",
  "close_date",
  "buyer",
  "user_tag",
  "published_date",
  "expiry_date",
  "award_date",
  "start_date",
  "value",
  "country",
  "suppliers",
  "is_sme",
  "qualification",
  "hidden_date",
  "buyer_categories",
  "assignee",
  "buyer_list_id",
  "buyer_list_ids",
  "framework"
] as const;

export const RelevanceScoreEnum = {
  High: "High",
  Medium: "Medium",
  Low: "Low",
  None: "None",
} as const;
export type RelevanceScoreEnum =
  (typeof RelevanceScoreEnum)[keyof typeof RelevanceScoreEnum];
